import {
  LabelProcedure,
  LabelProcedureFilter,
} from '@/modules/copay/entities/interfaces/usageStatements';
import { ListResponse } from '@/shared/hooks/useRequestData/useRequestPaginatedList';
import HttpClientAdapter from '@/shared/services/httpClientAdapter';

export class LabelProcedureService extends HttpClientAdapter {
  constructor() {
    super('FINANCIAL');
  }

  getLabelProcedures(payload?: Partial<LabelProcedureFilter>[]) {
    return this.get<ListResponse<LabelProcedure>>('/label-procedures', payload);
  }
}
